import styled from 'styled-components';
import {controlWithIcon} from  '../../../common/shared/control-with-icon.styled';

export const StyledTenantsList = styled.section`
  ${controlWithIcon()}

  #section-to-print {
    width: 100%;
    position: absolute; 
    bottom: 5000px;
  }
  
  .actions-toolbar-search {
    input {
      padding-left: 60px;
    }
  }
  
  .toolbar {
    padding: 50px 0 40px;
  }
  
  #table {
    max-height: 500px;
  }
  .ensure-height + .actions-toolbar {
    padding-top: 0;
  }
  .save-btn {
    display: flex;
    justify-content: flex-end;
  }
  .bllink-button {
    max-width: 170px;
    &:disabled {
      opacity: .5;
    }
  }

  @media screen and (max-width: 768px) {
    .title-wrapper {
      margin-inline-end: 0;

      .icons-bar {
        display: none;
      }
    }

    .actions-toolbar-search {
      width: 100%;

      .control-with-icon {
        width: 100%;

        input {
          width: 100%;
        }
      }
    }
  }
`;
